import { createGlobalStyle } from "styled-components";

export const GlobalUtilsStyled = createGlobalStyle`
    .text-left {
        text-align: left;
    }

    .text-right {
        text-align: right;
    }

    .text-primary {
        color: var(--color-label-primary) !important;
    }

    .text-secondary {
        color: var(--color-label-secondary) !important;
    }

    .text-warning {
        color: var(--color-button-primary-default) !important;
    }

    .color-white-60 {
        color: var(--color-label-secondary) !important;
    }

    .block-title {
        font-size: 16px;
        font-weight: 600;
        color: var(--color-label-secondary);
        padding-bottom: 12px;
    }

    .flex-1 {
        flex: 1;
    }

    .mt-2rem {
        margin-top: 2rem !important;
    }

    .color-red {
        color: var(--color-label-negative) !important;
    }

    .f12,
    .font-size-12 {
        font-size: 12px;
    }

    .f14,
    .font-size-14 {
        font-size: 14px;
    }

    .f16,
    .font-size-16 {
        font-size: 16px;
    }

    .f20,
    .font-size-20 {
        font-size: 20px;
    }

    .f24,
    .font-size-24 {
        font-size: 24px;
    }

    .f28,
    .font-size-28 {
        font-size: 28px;
    }

    .fw400 {
        font-weight: 400;
    }

    .fw600 {
        font-weight: 600;
    }

    .fw700 {
        font-weight: 700;
    }

    .font-weight-normal {
        font-weight: normal;
    }

    .lh16 {
        line-height: 16px;
    }

    .lh20 {
        line-height: 20px;
    }

    .lh24 {
        line-height: 24px;
    }

    .lh28 {
        line-height: 28px;
    }

    .visibility-hidden {
        visibility: hidden;
    }

    .react-financial-charts-x-axis {
        z-index: 0;
    }

    .custom-scrollbar {
        &::-webkit-scrollbar {
            cursor: pointer;
            background: transparent;
            height: 4px;
            width: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: var(--color-label-tertiary);
            border-radius: 10px;
        }
    }

    .hidden-scrollbar {
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */

        &::-webkit-scrollbar {
            display: none;
        }
    }

    // https://bhch.github.io/posts/2021/04/centring-flex-items-and-allowing-overflow-scroll/
    .flex-justify-center-scroll {
        > *:first-child {
            margin-left: auto;
        }

        > *:last-child {
            margin-right: auto;
        }
    }

    // https://bhch.github.io/posts/2021/04/centring-flex-items-and-allowing-overflow-scroll/
    .flex-justify-center-scroll {
        > *:first-child {
            margin-left: auto;
        }

        > *:last-child {
            margin-right: auto;
        }
    }

    @keyframes gradient {
        0% {
            background-position: 0% 50%;
        }
        100% {
            background-position: 300% 50%;
        }
    }

    // три типаразмера для радиуса границ (8, 12, 16)
    .skeleton-br16 {
        border-radius: 16px;
        color: transparent !important;
        background: linear-gradient(-90deg,
        rgba(129, 146, 228, 0.1),
        rgba(129, 146, 228, 0.3),
        rgba(129, 146, 228, 0.1));
        background-size: 300% 100%;
        animation: gradient 5s ease infinite;
    }

    .skeleton-br12 {
        border-radius: 12px;
        color: transparent !important;
        background: linear-gradient(-90deg,
        rgba(129, 146, 228, 0.1),
        rgba(129, 146, 228, 0.3),
        rgba(129, 146, 228, 0.1));
        background-size: 300% 100%;
        animation: gradient 5s ease infinite;
    }

    .skeleton-br8 {
        border-radius: 8px;
        color: transparent !important;
        background: linear-gradient(-90deg,
        rgba(129, 146, 228, 0.1),
        rgba(129, 146, 228, 0.3),
        rgba(129, 146, 228, 0.1));
        background-size: 300% 100%;
        animation: gradient 5s ease infinite;
    }

    .wave-background {
        background: linear-gradient(-90deg,
        rgba(129, 146, 228, 0.1),
        rgba(129, 146, 228, 0.3),
        rgba(129, 146, 228, 0.1));
        background-size: 300% 100%;
        animation: gradient 5s ease infinite;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .surface-secondary {
        background-color: var(--color-background-secondary);
        border-radius: 12px;
        padding: 8px 16px;
    }
    
    .shadow-primary {
        box-shadow: var(--shadow-primary);
    }

    .backdrop-filter-blur20 {
        backdrop-filter: blur(20px);
    }

    .backdrop-filter-blur100 {
        backdrop-filter: blur(100px);
    }

    .dot-4 {
        width: 4px;
        height: 4px;
        background: var(--color-label-secondary);
        border-radius: 100%;
    }

    .custom-link {
        color: var(--color-label-accent);

        &:hover {
            color: var(--color-button-primary-highlight);
        }
    }
    
    .hover-opacity {
        &:hover {
            cursor: pointer;
            opacity: 0.8;
        }
    }
    
    .hover-bright {
        &:hover {
            cursor: pointer;
            filter: brightness(1.3);
        }
    }

    .word-break-word {
        word-break: break-word;
    }
    
    .top-0 {
        top: 0;
    }

    .bottom-0 {
        bottom: 0;
    }

    .right-0 {
        right: 0;
    }

    .left-0 {
        left: 0;
    }
    
    .z-index-1 {
        z-index: 1;
    }
`;
